import { Input } from "common/InputForm";
import useButtonLoader from "hooks/useButtonLoader";
import { CustomButton } from "components/form";
import React, { useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { forgetApi } from "services/auth";
import { toastMessage } from "utils/toastMessage";
import { auth } from "validation/schema/auth";
import { ValidateInput } from "validation";
import { authImage } from "assets/images";

const ForgotPassword = ({ data, setData, setSteps }) => {
  const [buttonLoader, setButtonLoader] = useButtonLoader("Reset Password");
  const [error, setError] = useState("");

  // Input Validtion
  const validation = () => {
    const { errors, status } = ValidateInput(
      data,
      "forgotPasswordSchema",
      auth,
      null
    );
    setError(errors);
    return status;
  };

  // on change handler
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  // Forget password handler
  const forgetPasswordHandler = async (e) => {
    e.preventDefault();
    if (validation()) {
      try {
        setButtonLoader(true);
        const { data: responseData, status } = await forgetApi({
          email: data?.email,
          otpType: "FORGOT",
        });
        if (status === 200) {
          toastMessage(responseData?.message, "success", "forgotPassword");
          setData({ email: data?.email });
          setSteps(6);
        }
      } catch (e) {
        console.log("error", e);
      } finally {
        setButtonLoader(false);
      }
    }
  };

  return (
    <>
      <div className="auth_section">
        <div className="image_section">
          <img src={authImage} alt="" />
        </div>
        <form>
          {/* <div className="back_button">
            <button
              type="button"
              onClick={() => {
                setSteps(1);
                setData({});
              }}
            >
              <IoIosArrowBack /> Back to login
            </button>
          </div> */}

          <div className="form_title">
            <h3>Forgot Password?</h3>
            <p>
              No worries, we've got you covered! Enter your email address below
              and we'll send you a otp to reset your password.
            </p>
          </div>
          <div className="form_field">
            <Input
              label="Email"
              placeholder="Enter Email"
              name="email"
              maxLength={40}
              value={data.email}
              onChange={onChangeHandler}
              error={error?.email}
              extraError={error?.emailErr}
            />
          </div>
          <div className="button_wrap button_right">
            <CustomButton
              type="submit"
              className="button w-100"
              onClick={forgetPasswordHandler}
              ref={buttonLoader}
            >
              Reset Password
            </CustomButton>
          </div>
        </form>
      </div>
    </>
  );
};

export default ForgotPassword;
